import React from "react";
import "../../css/tp-sect4.css";
import ExamList from "../ExamList";

const Sect4 = () => {
  return (
    <section id="tp-sect4">
      <article>
        <h2>Create courses for your favorite subjects</h2>
        <div id="sect3-exam-list-cont">
          <ExamList />
        </div>
        <p>Everything is set for you to get started</p>
        <button>Get started</button>
      </article>
    </section>
  );
};

export default Sect4;
